var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMoreInfo = function SvgIcoMoreInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.5 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0m-2 0c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.795 7.294A.97.97 0 0 1 12.502 7q.412 0 .705.294a.97.97 0 0 1 .293.709.96.96 0 0 1-.293.705.96.96 0 0 1-.705.292.97.97 0 0 1-.707-.292.95.95 0 0 1-.295-.705q0-.414.295-.709M12.5 11a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIcoMoreInfo;